import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import Grid from '@material-ui/core/Grid';
import { API_URL } from '../common/Constants';
import axios from 'axios';
import './introduction.css';

// import TitleText from '../common/TitleText';
// import Pagination from './Pagination';

const styles = (theme) => ({
  content_bg: {
    backgroundColor: '#fff',
    margin: '0 auto',
    width: '930px',
    padding: '0 80px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 30px',
      width: '100%',
    },
  },

  exImg: {
    width: '100%',
    height: '186px',
    overflow: 'hidden',
    borderRadius: '12px',
    margin: 0,
  },

  examplesWeb: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  examplesMob: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
});
const examples = [
  { img: './images/certification/ex1@2x.png', text: '성남누비길' },
  { img: './images/certification/ex2@2x.png', text: '송파둘레길' },
  { img: './images/certification/ex3@2x.png', text: '구리둘레길' },
  { img: './images/certification/ex4@2x.png', text: '동해여행 스탬프투어' },
  { img: './images/certification/ex5@2x.png', text: '수원화성 성곽길' },
  { img: './images/certification/ex6@2x.png', text: '해남군 남도명품길 달마고도' },
  { img: './images/certification/ex7@2x.png', text: '예산 스탬프투어' },
  { img: './images/certification/ex8@2x.png', text: '단양 스탬프투어' },
  { img: './images/certification/ex9@2x.png', text: '예산 스탬프투어 (출렁다리)' },
  { img: './images/certification/ex10@2x.png', text: '부산갈맷길' },
  { img: './images/certification/ex11@2x.png', text: '버그내순례길' },
  { img: './images/certification/ex12@2x.png', text: '장봉도갯티길' },
  { img: './images/certification/ex13@2x.png', text: '봉평 메밀꽃 스탬프투어' },
  { img: './images/certification/ex14@2x.png', text: '봉평 메밀꽃 스탬프투어' },
  { img: './images/certification/ex15@2x.png', text: '등대 스탬프투어' },
];
class Verify extends Component {
  constructor(props) {
    super(props);

    this.state = { currentPage: 0, perPage: 6, imgData: '' };
    this.changePage = this.changePage.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${API_URL}/admin/menuInfo`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        // console.log(response.data);
        let _result = response.data;
        this.setState({ imgData: _result });
        // console.log('imgData', this.state.imgData);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  componentWillUnmount() {}
  changePage(e, direction) {
    if (direction === 'prev') {
      if (this.state.currentPage > 0) {
        this.setState({ currentPage: this.state.currentPage - 1 });
      }
    } else {
      if (this.state.currentPage < parseInt(examples.length / this.state.perPage)) {
        this.setState({ currentPage: this.state.currentPage + 1 });
      }
    }
  }
  render() {
    // const { classes } = this.props;
    // const { currentPage, perPage } = this.state;
    // const indexFirst = perPage * currentPage;
    // const indexLast = indexFirst + perPage;
    // const showExamples = examples.slice(indexFirst, indexLast);
    return (
      <React.Fragment>
        <Topbar />
        <div className="dw_bg">
          <Grid
            id="index_grid"
            container
            justify="flex-start"
            style={{ padding: '2vh calc(2vw - 30px)', color: '#1b1d54', fontSize: '1.3em' }}
          >
            <b>제품소개 〉 스탬프 인증대</b>
          </Grid>
          <div className="bg_inner">
            <img
              src={this.state.imgData.m2_3}
              alt={'img'}
              style={{ width: '100%', paddingTop: '4vh', WebkitTouchCallout: 'none' }}
              onContextMenu={(e) => e.preventDefault()}
            />
            {/* <TitleText title="스탬프 인증대" />
            <p align="center" className="mainTxt">
              수년간의 연구와
              <br className={classes.examplesMob} /> 개발의 결실
            </p>
            <Grid container justify="center" alignItems="center">
              <img src="./images/certification/circles@2x.png" alt="" className="circles" style={{WebkitTouchCallout: 'none'}} />
            </Grid>

            <p align="center" className="descTxt">
              <span style={{ fontSize: '0.9em' }}>견고한 결속 구조 / 이중 자동문닫힘 기능 구조 / 부식방지형 구조</span>
              <br /> 위의 특장점을 살려 <span style={{ color: '#f05757', fontSize: '1.1em' }}>특수한 구조</span>로{' '}
              <span style={{ color: '#f05757', fontSize: '1.1em' }}>제작</span>
              되었습니다.
            </p>
            <Grid container justify="center" alignItems="center">
              <img src="./images/certification/certification.png" alt="인증대" style={{ width: '100%', WebkitTouchCallout: 'none' }} />
            </Grid>
            <Grid container direction="column" className="grayBox">
              <p className="infoTxt">
                <img src="./images/stampbook/ic_info.png" alt="infomation" style={{ verticalAlign: 'bottom', WebkitTouchCallout: 'none' }} /> <b>스탬프 인증대</b>란?
              </p>
              <div className="features">
                스탬프 인증대는 <b>두원시스템만의 특허와 함께 특수한 스탬프</b>를 완벽하게 탑재하고 <b>대상처 컨셉에 맞게 맞춤 디자인</b>을
                기획하여 조형미를 갖도록 제작됩니다.
                <br />큰 형태로는 새집형, 경사지붕형, 특수맞춤형이 있으며, 소재 또한 스탬프투어의&nbsp;
                <b>컨셉에 따라 나무, 스테인레스, FRP 등의 우수한 재질로 제작</b>되어 설치됩니다. 견고한 결속구조를 바탕으로{' '}
                <b>민원이 없는 특수한 인증대</b> 입니다.
              </div>
            </Grid>

            <Grid>
              <Pagination
                pageText="설치 사례"
                examples={examples}
                currentPage={this.state.currentPage}
                perPage={this.state.perPage}
                changePage={this.changePage}
              />
            </Grid>
            <Grid container className={classes.examplesMob} spacing={3} style={{ paddingTop: '20px' }}>
              {showExamples.map((example, idx) => (
                <Grid key={idx} container item direction="column" alignItems="center" xs={6}>
                  <p style={{ width: '100%', margin: 0, overflowY: 'hidden', overflow: 'hidden' }}>
                    <img src={example.img} alt="infomation" style={{ width: '100%', borderRadius: '12px', WebkitTouchCallout: 'none' }} />
                  </p>
                  <p style={{ fontSize: '1.1em', wordBreak: 'keep-all', textAlign: 'center' }}>{example.text}</p>
                </Grid>
              ))}
            </Grid>
            <Grid container className={classes.examplesWeb} justify="space-between" style={{ paddingTop: '40px' }}>
              {examples.map((example, idx) => (
                <Grid key={idx} container item direction="column" alignItems="center" style={{ width: '18%', marginBottom: '20px' }}>
                  <p className={classes.exImg}>
                    <img src={example.img} alt="infomation" style={{ width: '100%', WebkitTouchCallout: 'none' }} />
                  </p>
                  <p className="exTxt">{example.text}</p>
                </Grid>
              ))}
            </Grid> */}
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(Verify));
